<h1 mat-dialog-title style="text-align: center">{{ DialogTitle }}</h1>
<div mat-dialog-content style="text-align: center">
  {{ DialogDescription }}
  <div class="row-container">
    <div class="row-label">
      Is Mandatory?
    </div>
    <div class="row-item">
      {{attribute.IsMandatory }}
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Help Text
    </div>
    <div class="row-item">
      {{attribute.HelpText}}
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Is Always Hidden
    </div>
    <div class="row-item">
      {{attribute.IsAlwaysHidden}}
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Is Custom Field
    </div>
    <div class="row-item">
      {{attribute.IsCustomField}}
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Group Name
    </div>
    <div class="row-item">
      {{attribute.GroupName}}
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Visibility When Rules
    </div>
    <div class="row-item">
      @for (rule of attribute.VisibleWhenRules; track rule) {
        <div>
          {{rule.PropertyName | prettify}}
          =
          {{rule.ValueIs.Value | prettify}}
        </div>
      }
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Visibility When OR Rules
    </div>
    <div class="row-item">
      @for (rule of attribute.VisibleWhenOrRules; track rule) {
        <div>
          {{rule.PropertyName | prettify}}
          =
          {{rule.ValueIs.Value | prettify}}
        </div>
      }
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Mandatory When Rules
    </div>
    <div class="row-item">
      @for (rule of attribute.MandatoryWhenRules; track rule) {
        <div>
          <div>
            {{rule.PropertyName | prettify}}
            =
            {{rule.ValueIs.Value  | prettify}}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Mandatory When OR Rules
    </div>
    <div class="row-item">
      @for (rule of attribute.MandatoryWhenOrRules; track rule) {
        <div>
          <div>
            {{rule.PropertyName  | prettify}}
            =
            {{rule.ValueIs.Value | prettify}}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Hide When Rules
    </div>
    <div class="row-item">
      @for (rule of attribute.HideWhenRules; track rule) {
        <div>
          <div>
            {{rule.PropertyName  | prettify}}
            =
            {{rule.ValueIs.Value | prettify}}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="row-container">
    <div class="row-label">
      Hide When OR Rules
    </div>
    <div class="row-item">
      @for (rule of attribute.HideWhenOrRules; track rule) {
        <div>
          <div>
            {{rule.PropertyName  | prettify}}
            =
            {{rule.ValueIs.Value | prettify}}
          </div>
        </div>
      }
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="mat-warn" style="margin: 5px" (click)="closeDialog()">{{ DialogConfirmButtonText }}</button>
</div>
